import { PropsWithChildren } from 'react';

interface EmptyFieldInterface {
  hidden?: boolean;
}

export const EmptyField = ({ hidden, children }: PropsWithChildren<EmptyFieldInterface>) => (
  <>{children && !hidden ? children : '—'}</>
);
